import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["depth"],
  _excluded2 = ["hidden"],
  _excluded3 = ["selected"],
  _excluded4 = ["depth", "parent", "collapsible", "selected", "link"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.string.link.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { COLORS } from "../../constants/colors";
import { GRAY, BLUE } from "../../constants/colors/hex";
import ArrowRight from "../../icons/ArrowChevronRight";
import Checkmark from "../../icons/CheckMarkOutline";
import Minus from "../../icons/MinusOutline";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _MenuRowValue = styled(function (_ref) {
  var depth = _ref.depth,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _MenuRowArrow = styled(function (_ref2) {
  var hidden = _ref2.hidden,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(ArrowRight, rest);
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  visibility: ", ";\n  * {\n    fill: ", ";\n  }\n"])), function (props) {
  return props.hidden ? 'hidden' : 'visible';
}, GRAY[5]);
export var _MenuRowBox = styled(function (_ref3) {
  var selected = _ref3.selected,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("div", rest, selected ? /*#__PURE__*/React.createElement(Checkmark, null) : /*#__PURE__*/React.createElement(Minus, null));
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  box-sizing: border-box;\n  margin-right: 8px;\n  border: ", ";\n  background-color: ", ";\n  svg {\n    display: ", ";\n    * {\n      fill: white;\n    }\n  }\n"])), function (props) {
  return props.selected ? 'none' : "solid 2px ".concat(GRAY[15]);
}, function (props) {
  return props.selected ? COLORS.primary.main : 'transparent';
}, function (props) {
  return props.selected ? 'block' : 'none';
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _MenuRowRoot = styled(function (_ref4) {
  var depth = _ref4.depth,
    parent = _ref4.parent,
    collapsible = _ref4.collapsible,
    selected = _ref4.selected,
    link = _ref4.link,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  if (link) {
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return /*#__PURE__*/React.createElement("a", _extends({
      href: link
    }, rest));
  }
  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  flex-flow: nowrap;\n  padding: 8px 16px;\n  padding-left: calc(16px + ", "px);\n  text-decoration: none;\n  color: ", ";\n\n  background-color: ", ";\n\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:active,\n  &:focus {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.depth ? props.depth * 32 : 0;
}, GRAY[5], function (props) {
  var blue = props.selected;
  if (props.parent) {
    blue = false;
  }
  return blue ? BLUE[19] : 'transparent';
}, GRAY[5], function (props) {
  if (!props.collapsible && props.parent) {
    return 'initial';
  }
  if (props.selected) {
    return BLUE[19];
  }
  return 'white';
}, GRAY[20]);
export var _Icon = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-right: 8px;\n"])));
export var _MenuRows = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  &:focus {\n    outline: none;\n  }\n\n  padding: 8px 0px;\n"])));